import React, { useState } from 'react';
import styled from '@emotion/styled';
import { AutoNav } from './AutoNav';
import { navigationItems } from 'constants/blogNavigation';
import { Link } from 'components/Link/Link';
import { Colors } from '@zapier/design-system';

export function SecondaryNavigation() {
  const [currentItem, setCurrentItem] = useState(navigationItems[0]);
  return (
    <Outer>
      <NavWrapper>
        <AutoNav
          items={navigationItems}
          onChooseItem={(item) => {
            setCurrentItem(item);
          }}
          selectedItemHref={currentItem.href}
          isItemSelected={(item, selectedItemHref) =>
            item.href === selectedItemHref
          }
          size="medium"
          underlineSelectedItem={false}
          linkComponent={Link}
          shouldRenderTrack={false}
        />
      </NavWrapper>
    </Outer>
  );
}

const Outer = styled.div`
  background: ${Colors.white};
  border-bottom: 1px solid ${Colors.grey200};
  position: sticky;
  top: 0;
  z-index: 50;
`;

const NavWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;
